
/**
 * The line icons the registration screen draws.
 *
 * The kit ships no icon set, and both presenters used to carry their own copy of
 * these twenty paths at two different sizes. One copy, one size prop.
 */
const Ic = ({ d, size = 18, sw = 1.7, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...rest}>
    {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
  </svg>
);

export const MicIcon       = p => <Ic {...p} d={['M12 2a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z','M19 10v1a7 7 0 0 1-14 0v-1','M12 18v4M8 22h8']} />;
export const StopIcon      = p => <Ic {...p} d="M7 7h10v10H7z" sw={0} />;
export const CheckIcon     = p => <Ic {...p} d="m5 12 4.5 4.5L19 7" />;
export const CloseIcon     = p => <Ic {...p} d={['M18 6 6 18','M6 6l12 12']} />;
export const PlusIcon      = p => <Ic {...p} d={['M12 5v14','M5 12h14']} />;
export const TrashIcon     = p => <Ic {...p} d={['M3 6h18','M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6','M10 11v6','M14 11v6']} />;
export const PillIcon      = p => <Ic {...p} d={['M10.5 20.5a5 5 0 0 1-7-7l6-6a5 5 0 0 1 7 7z','m8 8 7 7']} />;
export const SparkleIcon   = p => <Ic {...p} d={['M12 3l1.8 4.9L18 9.7l-4.2 1.8L12 16l-1.8-4.5L6 9.7l4.2-1.8z','M19 14l.7 1.8L21 16.5l-1.3.7L19 19l-.7-1.8L17 16.5l1.3-.7z']} />;
export const CoinIcon      = p => <Ic {...p} d={['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z','M12 7v10','M14.5 9.5A2.5 2.5 0 0 0 12 8h-.5a2 2 0 0 0 0 4h1a2 2 0 0 1 0 4H12a2.5 2.5 0 0 1-2.5-1.5']} />;
export const UserIcon      = p => <Ic {...p} d={['M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z','M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1']} />;
export const ShieldIcon    = p => <Ic {...p} d="M12 3l8 3v5c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z" />;
export const ClipboardIcon = p => <Ic {...p} d={['M9 4h6v3H9z','M7 5H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1','M9 12h6','M9 16h4']} />;
export const HealthIcon    = p => <Ic {...p} d={['M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z','M12 9v6','M9 12h6']} />;
export const BadgeIcon     = p => <Ic {...p} d={['M12 14a5 5 0 1 0 0-10 5 5 0 0 0 0 10z','M8.5 13l-1.5 8 5-3 5 3-1.5-8']} />;
export const HeartIcon     = p => <Ic {...p} d="M19 14c1.5-1.5 3-3.2 3-5.5A4.5 4.5 0 0 0 12 5.5 4.5 4.5 0 0 0 2 8.5c0 2.3 1.5 4 3 5.5l7 7z" />;
export const DropIcon      = p => <Ic {...p} d="M12 2C12 2 5 10 5 14a7 7 0 0 0 14 0C19 10 12 2 12 2z" />;

/** The insurer cards, by `INSURANCES(t)` id. */
// Keyed by CATALOG id (insurers.id), not by the four ids this screen used to
// invent. A catalog row with no icon here simply renders without one — the list
// is platform-owned and may grow between releases of this client, so a missing
// entry must never blank the option.
export const INS_ICONS = {
  tamin: HealthIcon,
  armed: BadgeIcon,
  salamat: HeartIcon,
  azad: ClipboardIcon,
};

export default Ic;
